import styled from 'styled-components';

export const StyledOSTagsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

export const StyledPovTag = styled.span<{ label: string }>`
  padding: 0.7rem 1.2rem;
  background-color: ${({ theme, label }) => (label === 'Blue' ? theme.colors.info.lightest : 'rgba(235, 0, 55, 0.2)')};
  color: ${({ theme, label }) => (label === 'Blue' ? theme.colors.info.main : 'rgba(235, 0, 55, 1)')};
  border-radius: ${({ theme }) => theme.radius.huge};
  cursor: pointer;
`;
